import { useContext, createContext } from 'react';
import { isNil } from 'lodash';
import { IAuthContextValue } from './auth.interfaces';

export const AuthContext = createContext<IAuthContextValue | undefined>(undefined);

export const useAuth = (): IAuthContextValue => {
  const ctx = useContext(AuthContext);

  if (isNil(ctx)) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return ctx;
};
